import { render, staticRenderFns } from "./FeeScheduleList.vue?vue&type=template&id=e5c38218&scoped=true"
import script from "./FeeScheduleList.vue?vue&type=script&lang=js"
export * from "./FeeScheduleList.vue?vue&type=script&lang=js"
import style0 from "./FeeScheduleList.vue?vue&type=style&index=0&id=e5c38218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c38218",
  null
  
)

export default component.exports